import React from "react";
import { Paper, Stack } from "@mui/material";
import { actionsBarSx } from "./FormActionsBar.styles";

export default function FormActionsBar({ children }) {
  return (
    <Paper elevation={0} sx={actionsBarSx}>
      <Stack direction="row" spacing={1} alignItems="center">
        {children}
      </Stack>
    </Paper>
  );
}